/**
 * Modes Style03 - Stitch v2: gold theme, tune icon, mode buttons
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import { resolveModesFromAttributes } from './traitStyleConfig'
import { getTraitConfig } from './traitStyleConfig'
import './ModesStyle03.css'

export function ModesStyle03({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { icon } = getTraitConfig(trait)
  const modes = resolveModesFromAttributes(attributes, trait)
  const ids = modes.length ? modes : ['mode1', 'mode2', 'mode3']
  const current = (state?.currentMode ?? state?.mode ?? ids[0]) as string
  const [value, setValue] = useState(current)

  useEffect(() => {
    setValue((state?.currentMode ?? state?.mode ?? ids[0]) as string)
  }, [state?.currentMode, state?.mode, ids])

  return (
    <div className="trait-modes-style03 trait-stitch-v2-glass">
      <div className="trait-modes-style03__header">
        <span className="trait-modes-style03__title">Modes</span>
        <span className={`material-symbols-outlined trait-modes-style03__icon`}>{icon}</span>
      </div>
      <div className="trait-modes-style03__grid">
        {ids.map((id) => (
          <button
            key={id}
            type="button"
            className={`trait-modes-style03__btn ${value === id ? 'active' : ''}`}
            onClick={() => !disabled && (setValue(id), void onCommand('setMode', { mode: id }))}
            disabled={disabled}
          >
            {id}
          </button>
        ))}
      </div>
    </div>
  )
}
